import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType } from "@ngx-formly/core";

@Component({
  standalone: false,
  selector: "formly-button",
  templateUrl: "./button.component.html",
  styleUrls: ["../../styles/modern-page-layout.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldButton extends FieldType {

  // CHAT-939: `base`, not `primary`. A Formly button is an in-form action --
  // "Try It", "Test" -- and primary is one-per-page, reserved for the commit
  // action in the form's own action row. A field config can still opt into
  // another role explicitly.
  override defaultOptions = {
    props: {
      type: 'button',
      themeColor: 'base',
    }
  };

  onClick() {
    if (this.props.click) {
      this.props.click(this.field);
    }
  }

}
